// removed by extract-text-webpack-plugin
module.exports = {"linkContainer":"Login--linkContainer--VKsYv4I9","forgotLink":"Login--forgotLink--1OsmNIPQ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/auth/Views/Login.css
// module id = 1309
// module chunks = 2